webpackJsonp([136],{

/***/ "./.intermediate-representation/json/v-12-0-0-introduction-community.json":
/***/ function(module, exports) {

	module.exports = {
		"data": {
			"markdownRemark": {
				"html": "<p>Want to chat about Exponent? The best way to get in touch with our team and other people developing with Exponent is to join our Slack chat. We always like to hear about projects and components that people are building on Exponent and there’s usually someone available to answer questions.</p>\n<ul>\n<li><a href=\"https://slack.getexponent.com/\">Request an invitation</a> to our <a href=\"https://exponentjs.slack.com/\">Slack</a>.</li>\n<li><a href=\"https://twitter.com/getexponent\">Follow us on Twitter @getexponent</a></li>\n<li><a href=\"https://github.com/exponent\">Become a contributor on Github</a></li>\n</ul>",
				"excerpt": "Want to chat about Exponent? The best way to get in touch with our team and other people developing with Exponent is to join our Slack chat...",
				"frontmatter": {
					"title": "Community",
					"prev": {
						"fileSlug": "/v12.0.0/introduction/xde-tour/",
						"children": [
							{
								"frontmatter": {
									"title": "XDE Tour"
								}
							}
						]
					},
					"next": {
						"fileSlug": "/v12.0.0/introduction/additional-resources/",
						"children": [
							{
								"frontmatter": {
									"title": "Additional Resources"
								}
							}
						]
					}
				}
			}
		},
		"pathContext": {
			"fileSlug": "/v12.0.0/introduction/community/"
		}
	};

/***/ }

});


// WEBPACK FOOTER //
// path---v-12-0-0-introduction-community-facc5205ad79ced2cb48.js